export default __webpack_public_path__ + "static/media/img-slider-om-wallet-2.9dfdec22.png";